/**
 * A button which displays mathquill content
 *
 * @class tinymce.ui.MathquillButton
 * @extends tinymce.ui.Button
 */
define("post-editor/MathquillButton", [
	"tinymce/ui/Button",
	"tinymce/ui/Factory",
	"tinymce/ui/DomUtils",
	"lib/jquery.mathquill"
], function(Button, Factory, DomUtils, _) {
	"use strict";

	var MathquillButton = Button.extend({
		/**
		 * Constructs a new control instance with the specified settings.
		 *
		 * @constructor
		 * @param {Object} settings Name/value object with settings.
		 * @setting {String} placeholder Placeholder text to display.
		 */
		init: function(settings) {
			var self = this;

			self._super(settings);
		},
		
		/**
		 * Called after the control has been rendered.
		 *
		 * @method postRender
		 */
		postRender: function() {
			var self = this, settings = this.settings;
			var button = $('#' + self._id + ' button');
			
			button
				.text('')
				.append(
					$('<div>')
					.addClass('button-mathquill')
					.text(self.settings.latex))
					// Prevents editing the formula in the button
					.append(
						$('<div>')
						.addClass('math-editor-button-clicktarget'));
			
			// do this after the divs have been inserted
			setTimeout(function() {
				button.find('.button-mathquill').mathquill()
			});

			return self._super();
		}
	});
	
	Factory.add('mathquillbutton', MathquillButton);
	return MathquillButton;
});

